import {styled} from "@mui/material/styles";
import { AccordionSummary} from "@mui/material";
import {primaryBlue} from "../../config";

export const ShuriStyledAccordionSummary = styled(AccordionSummary)(({theme}) =>({
    color: 'white',
    '.MuiAccordionSummary-expandIconWrapper': {
        color: primaryBlue
    }
}));